<template>
	<div  class="group1_L w_50"><!-- group1_L -->
		<ul class="title1">
			<li class="L">实时新闻</li>
			<li class="M"></li>
			<!-- <li class="R"><a href=""  class="more3">更多</a></li> -->
		</ul>
		<ul  class="zjzs_list"  >
			<li v-for="(item,index) in articlesList">
				<span class="cate"  >{{item.exattribute1}}</span>
				<a @click="jumppush('/detail/'+item.id+'?col=tuijian')" class="cate_news" target="_blank">{{item.title}}</a>
			</li>
			<!-- <li><span href="" class="cate"  >1分钟前</span><a href=""  class="cate_news" >2022年地方债发行启动 数万亿元驰援基建资金在路上</a></li>
			<li><span href="" class="cate"  >5分钟前</span><a href=""  class="cate_news" >2022年地方债发行启动 数万亿元驰援基建资金在路上</a></li>
			<li><span href="" class="cate"  >10分钟前</span><a href=""  class="cate_news" >2022年地方债发行启动 数万亿元驰援基建资金在路上</a></li>
			<li><span href="" class="cate"  >10分钟前</span><a href=""  class="cate_news" >2022年地方债发行启动 数万亿元驰援基建资金在路上</a></li> -->
		</ul>
	</div><!-- /group1_L -->
</template>

<script>
	export default{
		data() {
			return {
				hasPower:true,
				loadingMask:false,
				articlesList:[],
			}
		},
		mounted:function(){
			this.getArticles();
		},
		methods:{
			authcheck:function(){
				// this.hasPower=false;
				// if(!this.$cookies.get('userauth')){
				// 	this.hasPower=true;
				// }
				// else{
				// 	if(this.$cookies.get('userauth')=='1921f9e1416473a1d0f15d328e837115'){
				// 		this.hasPower=true;
				// 	}
				// 	if(this.$cookies.get('userauth').indexOf('tuijian')>-1){
				// 		this.hasPower=true;
				// 	}
				// }
			},
			jumppush:function(to){
				this.authcheck();
				if(!this.hasPower){
					alert('您未购买此栏目!');
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			getArticles:function(){
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'recommend/getLatestArticles',
						responseType: 'json',
						params: {
							iPage:'1',
							pageSize:'5',
						},
					})
					.then(function(response) {
						_this.articlesList=response.data.data.data.data
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			
		}
	}
</script>

<style>
</style>
